/** Shared enrichment block for utsava spans and dashboard panels. */
import { MantraAudioIcon } from "@/components/audio/MantraAudioIcon";
export function UtsavaSpanEnrichment({ sourceDay }) {
  const d = sourceDay;
  if (!d) return <p className="text-muted-foreground text-sm">No detail available.</p>;
  return (
    <div className="space-y-3 text-sm text-muted-foreground">
      {d.story && (
        <p>
          <span className="font-medium text-foreground">Story: </span>
          {d.story}
        </p>
      )}
      {d.puja_vidhi?.general?.length > 0 && (
        <div>
          <p className="font-medium text-foreground">Puja vidhi</p>
          <ul className="list-disc pl-5 mt-1">
            {d.puja_vidhi.general.slice(0, 6).map((line, i) => (
              <li key={i}>{line}</li>
            ))}
          </ul>
        </div>
      )}
      {d.sadhana_guide && (
        <div>
          <p className="font-medium text-foreground">Sādhana</p>
          {Object.entries(d.sadhana_guide).map(([k, v]) => (
            <p key={k} className="mt-1">
              <span className="capitalize">{k.replace(/_/g, " ")}: </span>
              {v}
            </p>
          ))}
        </div>
      )}
      {d.mantra && (
        <p>
          <span className="font-medium text-foreground">Mantra: </span>
          <span className="inline-flex items-center gap-2 text-primary">
            <span>{d.mantra}</span>
            <MantraAudioIcon mantra={d.mantra} />
          </span>
        </p>
      )}
      {d.do_and_dont && (
        <div className="grid sm:grid-cols-2 gap-2">
          {d.do_and_dont.do?.length > 0 && (
            <div>
              <p className="font-medium text-foreground">Do</p>
              <ul className="list-disc pl-5">
                {d.do_and_dont.do.slice(0, 4).map((x, i) => (
                  <li key={i}>{x}</li>
                ))}
              </ul>
            </div>
          )}
          {d.do_and_dont.dont?.length > 0 && (
            <div>
              <p className="font-medium text-foreground">Avoid</p>
              <ul className="list-disc pl-5">
                {d.do_and_dont.dont.slice(0, 4).map((x, i) => (
                  <li key={i}>{x}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
      {d.vedic_history_note && (
        <p>
          <span className="font-medium text-foreground">History: </span>
          {d.vedic_history_note}
        </p>
      )}
    </div>
  );
}
